import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=ec5eab9c"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports